import React from "react";
import Dropzone from "react-dropzone";
import Confirmalert from '../ThemeComponents/confirmAlert';
import { confirmAlert } from 'react-confirm-alert';
import { helperFunctions as HF} from '../../helper/helperFunctions';
    
class FileUpload extends React.Component {
  constructor(props){
    super(props);
    this.state = { 
      warningMsg : "",
      showAlert  : true,
    };
    this.replaceImageAlert = this.replaceImageAlert.bind(this);
    this.onDrop = this.onDrop.bind(this);
    this.dropzoneRef = React.createRef();
  };
  toggle = () => {
    this.setState({showAlert:!this.state.showAlert });
  }
  extraHtml = () => {
    return(
      <span><i>Dont Show this pop up again</i><input type="checkbox" onClick={()=>this.toggle()} /></span>
    );
  }
  replaceImageAlert(index, fileObject){
    var self = this;
    return new Promise(function (resolve, reject) {
        const options = {
          customUI: ({ onClose }) => <Confirmalert 
                  header="Replace image with same name" 
                  description={"Are you sure to replace image "+fileObject.name+"?"} 
                  onClosePro={ onClose }
                  extraHtml={self.extraHtml}  
                  onNo={()=>{ resolve({replace:false}) }} 
                  onYes={()=>{ resolve({replace:true}) }} 
                />,
          closeOnEscape: false,
          closeOnClickOutside: false,
      };
    });
  }
   onDrop(accepted, rejected){
    console.log('accepted', accepted);
    console.log('rejected', rejected);
    if (Object.keys(rejected).length !== 0) {
      const message = "Please submit valid file type";
      this.setState({ warningMsg: message });
    } else {

      this.setState({ warningMsg: "" });
      const generateFile = (count, fileObject) => {
        return new Promise((resolve, reject) => {
          const reader = new window.FileReader();
          console.log('fileObject', fileObject);
          reader.readAsDataURL(fileObject);
          reader.onloadend = () => {
            fileObject['file'] = reader.result;
            return resolve({index:count, fileObject:fileObject});
          };
        });
      };
      if (this.props.multiple) {
        for (var i=0; i < accepted.length; i++){
          var temp = accepted[i];
          if (this.props.allowDuplicate) {
            generateFile(i, temp).then((value)=>{
              console.log('1');
              this.props.setResourceFile(this.props.type?this.props.type:null, value.fileObject); //add file data to file aray
            });
          } else {
            var chechDuplicate =  HF.removeDuplicateImage(temp, this.props.files);
            if (chechDuplicate.duplicate && this.props.askToUpdate){      
              if (this.state.showAlert) {
                const confirmBox = this.replaceImageAlert(chechDuplicate.index, chechDuplicate.val);
                if (confirmBox.replace) {
                  generateFile(chechDuplicate.index, chechDuplicate.val).then((value)=>{
                    console.log('2');
                    this.props.updateResourceFile(value.index, value.fileObject); //add file data to file aray
                  });
                }
              } else {
                generateFile(chechDuplicate.index, chechDuplicate.val).then((value)=>{
                  console.log('3');
                  this.props.updateResourceFile(value.index, value.fileObject); //add file data to file aray
                }); 
              }
            }
            else if (chechDuplicate.duplicate && this.props.updateWithoutAsking) {
              generateFile(chechDuplicate.index, temp).then((value)=>{
                console.log('4');
                this.props.updateResourceFile(value.index, value.fileObject); //add file data to file aray
              });
            } else {
              generateFile(i, temp).then((value)=>{
                console.log('5');
                this.props.setResourceFile(this.props.type?this.props.type:null, value.fileObject); //add file data to file aray
              });
            }
          }
        }
      } else {
        generateFile(0, accepted[0]).then((value)=>{
          console.log('6');
          this.props.setResourceFile(this.props.type?this.props.type:null, value.fileObject); //add file data to file aray
        });
      }
    }
  };

  open(){
    if(this.dropzoneRef.current){
      this.dropzoneRef.current.open();
    }
  }

  render() {
    const { allowedMimesPro, allowedFormatsStringExtPro, multiple, title } = this.props;
    const render =
      <p className="hello">Please drop {title?title:'files'} here with format {allowedFormatsStringExtPro}</p>;

    return (
      <div>
        <p>{this.state.warningMsg}</p>
        <Dropzone 
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "10vh",
            border: " 2px dashed"
          }}
          multiple={multiple}
          accept={allowedMimesPro}
          onDrop={this.onDrop}
        >
          {
            (
              {getRootProps, getInputProps}
            ) => (
              <section>
                <div {...getRootProps()} >
                  <input {...getInputProps()} />
                  <p className="hello">Please drop {title?title:'files'} here with format {allowedFormatsStringExtPro}</p>
                </div>
              </section>
            )
          }
        </Dropzone>
      </div>
    );
  }
}

export default FileUpload;



// WEBPACK FOOTER //
// ./src/components/Upload/FileUpload.js